import { Type } from 'class-transformer';
import { IsBoolean, IsDate, IsDefined, IsNotEmpty, IsString, ValidateNested } from 'class-validator';
import { BaseDto } from '../../@base';
import { UserSessionId } from '../../types';

export class UserSessionUserAgentCoreDto {
  @IsString()
  @IsNotEmpty()
  device!: string;

  @IsString()
  @IsNotEmpty()
  location!: string;
}
export class UserSessionCoreDto extends BaseDto<UserSessionId> {
  @ValidateNested()
  @Type(() => UserSessionUserAgentCoreDto)
  @IsDefined()
  userAgent!: UserSessionUserAgentCoreDto;

  @IsBoolean()
  @IsNotEmpty()
  isCurrentSession!: boolean;

  @IsDate()
  lastLoginAt!: Date;
}
